import { render, staticRenderFns } from "./journalList.vue?vue&type=template&id=4659fd47&scoped=true&"
import script from "./journalList.vue?vue&type=script&lang=js&"
export * from "./journalList.vue?vue&type=script&lang=js&"
import style0 from "./journalList.vue?vue&type=style&index=0&id=4659fd47&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4659fd47",
  null
  
)

export default component.exports